import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.number.constructor.js";
import "regenerator-runtime/runtime.js";
import Nl2br from 'vue-nl2br';
var CountDown = function CountDown() {
  return import('@/components/molecules/CountDown');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var MultiPageModal = function MultiPageModal() {
  return import('@/components/organisms/MultiPageModal');
};
var PartySlider = function PartySlider() {
  return import('@/components/molecules/PartySlider');
};
export default {
  components: {
    Nl2br: Nl2br,
    CountDown: CountDown,
    Modal: Modal,
    MultiPageModal: MultiPageModal,
    PartySlider: PartySlider
  },
  props: {
    cooperationQuest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isRecruitmentModalShown: false,
      publicCheck: true,
      arenaVisibility: 'private',
      partyLv: 0,
      applicationRange: 0,
      description: '',
      selectedTemplate: 0
    };
  },
  computed: {
    templates: function templates() {
      return useDeckTemplateStore().getDeckTemplates;
    },
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    isPublicCheck: function isPublicCheck() {
      return this.publicCheck;
    },
    frontierMission: function frontierMission() {
      return useMissionStore().getFrontierMission;
    },
    partyLvs: function partyLvs() {
      return {
        0: 0,
        1: 80,
        2: 200,
        3: 300,
        4: 400,
        5: 500
      };
    },
    isPrimeDisabled: function isPrimeDisabled() {
      return !this.isPrime && this.selectedTemplate >= 3 && this.selectedTemplate <= 9;
    }
  },
  beforeMount: function beforeMount() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return useDeckTemplateStore().fetchDeckTemplates();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    recruitmentModalShown: function recruitmentModalShown() {
      this.isRecruitmentModalShown = true;
      if (this.frontierMission.cooperationType == 1) this.applicationRange = 1;
    },
    onClickPrivateRadio: function onClickPrivateRadio() {
      if (this.publicCheck === true) this.publicCheck = !this.publicCheck;
    },
    onClickPublicRadio: function onClickPublicRadio() {
      if (this.publicCheck === false) this.publicCheck = !this.publicCheck;
    },
    cancel: function cancel() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return useNodeStore().cancelQuest();
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }))();
    },
    recruitmentStart: function recruitmentStart() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var initData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              initData = {
                missionId: _this.frontierMission.missionId,
                description: _this.description,
                isPublic: _this.publicCheck,
                partyLv: _this.partyLvs[_this.partyLv],
                heroIds: [],
                templateNo: _this.selectedTemplate,
                targetType: Number(_this.applicationRange)
              };
              _context3.next = 4;
              return _this.$questsService.createMission(initData);
            case 4:
              _context3.next = 6;
              return useNodeStore().clearQuest();
            case 6:
              _this.isRecruitmentModalShown = false;
              _this.$parent.isFinishRecruitModalShown = true;
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 10]]);
      }))();
    },
    selectTeamTemplate: function selectTeamTemplate(teamIndex) {
      return this.selectedTemplate = teamIndex;
    }
  }
};